export default {
    go: 'Go',
    operateDone: 'Operation done',
    goNextTask: 'Go to the next task',
    printConfirmTitle: 'Reminder',
    printConfirmContent: 'There is no support for system printing in Dingtalk, Please click OK to print in browser',
};
